import {
  CompanyCampaignPageQuery,
  CompanyCampaignPageRecord
} from '~/config/generated/graphql';

const handleCMSData = (cmsData: CompanyCampaignPageRecord) => {
  return {
    kvdHelperUrl: cmsData?._editingUrl,
    hero: cmsData?.hero,
    heroForm: {
      title: cmsData?.heroFormTitle,
      btnText: cmsData?.heroFormBtnText,
      description: cmsData?.heroFormDescription,
      success: cmsData?.heroFormSuccess
    },
    contactForm: {
      sectionTitle: cmsData?.contactFormSectionTitle,
      sectionDescription: cmsData?.contactFormSectionDescription,
      title: cmsData?.contactFormTitle,
      newsletterLabel: cmsData?.contactFormNewsletterLabel,
      btnText: cmsData?.contactFormBtnText,
      success: cmsData?.contactFormSuccess
    },
    fleetValComp: {
      title: cmsData?.fleetValCompTitle,
      averageProfitPerCar: cmsData?.fleetValCompAverageProfitPerCar as number,
      averageValuationDescription:
        cmsData?.fleetValCompAverageValuationDescription,
      kvdAverageValuation: cmsData?.fleetValCompKvdAverageValuation as number,
      kvdAverageValuationDescription:
        cmsData?.fleetValCompKvdAverageValuationDescription,
      dealerAverageValuation:
        cmsData?.fleetValCompDealerAverageValuation as number,
      dealerAverageValuationDescription:
        cmsData?.fleetValCompDealerAverageValuationDescription,
      disclaimer: cmsData?.fleetValCompDisclaimer,
      totalVehiclesInfo: cmsData?.fleetValCompTotalVehiclesInfo,
      kvdValuationTitle: cmsData?.fleetValCompKvdValuationTitle,
      kvdValuationDescription: cmsData?.fleetValCompKvdValuationDescription,
      dealerValuationTitle: cmsData?.fleetValCompDealerValuationTitle,
      dealerValuationDescription:
        cmsData?.fleetValCompDealerValuationDescription,
      resultTitle: cmsData?.fleetValCompResultTitle,
      resultDescription: cmsData?.fleetValCompResultDescription,
      usps: [
        cmsData?.fleetValCompUsp1,
        cmsData?.fleetValCompUsp2,
        cmsData?.fleetValCompUsp3
      ]
    },
    fleetValReport: {
      title: cmsData?.fleetValReportTitle,
      vehicleCountText: cmsData?.fleetValReportVehicleCountText,
      dealerTitle: cmsData?.fleetValReportDealerTitle,
      dealerDescription: cmsData?.fleetValReportDealerDescription,
      kvdTitle: cmsData?.fleetValReportKvdTitle,
      kvdDescription: cmsData?.fleetValReportKvdDescription,
      resultTitle: cmsData?.fleetValReportResultTitle,
      resultDescription: cmsData?.fleetValReportResultDescription,
      disclaimer: cmsData?.fleetValReportDisclaimer,
      processingMessage: cmsData?.fleetValReportProcessingMessage,
      expiredMessage: cmsData?.fleetValReportExpiredMessage,
      insights: {
        title: cmsData?.fleetValReportInsightsTitle,
        makeModel: {
          title: cmsData?.fleetValReportMakeModelTitle,
          description: cmsData?.fleetValReportMakeModelDescription,
          moreInfo: cmsData?.fleetValReportMakeModelMoreInfo
        },
        age: {
          title: cmsData?.fleetValReportAgeTitle,
          description: cmsData?.fleetValReportAgeDescription,
          recommendedLabel: cmsData?.fleetValReportAgeRecommendedLabel
        },
        fuel: {
          title: cmsData?.fleetValReportFuelTitle,
          description: cmsData?.fleetValReportFuelDescription
        },
        form: {
          title: cmsData?.fleetValReportFormTitle,
          description: cmsData?.fleetValReportFormDescription
        },
        recommendation: {
          title: cmsData?.fleetValReportRecommendationTitle,
          text: cmsData?.fleetValReportRecommendationText
        }
      }
    },
    modularSections: cmsData?.modularSections,
    seo: cmsData?.seo
  };
};

export const handleCompanyCampaignPage = ({
  companyCampaignPage
}: CompanyCampaignPageQuery) => {
  return handleCMSData(companyCampaignPage as CompanyCampaignPageRecord);
};
